import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { Person } from '../app.component';
import { Spot } from '../app.component';
import { SpotAction } from '../app.component';

import { APIhost } from '../app.component'

@Injectable()
export class PersonService {
	private profileUrl = APIhost + 'person.php';
	private peopleUrl = APIhost + 'people.php';

	constructor(private http: Http) { }

	getProfile(id: number): Promise<Person> {
		const url = `${this.profileUrl}?id=${id}`;
	  	return this.http.get(url)
	        .toPromise()
			.then(response => {
				var person = response.json() as Person;
				if (person.spot) {
					if (person.spot.assigned) {
						person.spot.action = SpotAction.vacate;
					} else if (person.spot.permanent) {
						if (person.spot.free_until) {
							person.spot.action = SpotAction.cancelVacation;
						} else {
							person.spot.action = SpotAction.vacateUntil;
						}
					} else {
						person.spot.action = SpotAction.none;
					}
				}
				
				return person;
			})
			.catch(this.handleError);
	}
	
	getPeople(): Promise<Person[]> {
		const url = `${this.peopleUrl}`;
	  	return this.http.get(url)
	        .toPromise()
			.then(response => response.json() as Person[])
			.catch(this.handleError);
	}

	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error);
	 	return Promise.reject(error.message || error);
	}
}


// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/user/user.service.ts